import { render } from "./InvoiceCard.vue?vue&type=template&id=0764bbdf"
import script from "./InvoiceCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__